import { UserProfile } from "@/redux/types";
import {
  getHeadersWithUniqueVisitorId,
  IAppInstallationInfo,
} from "@brandclub/common-ui";
import { HOST_DOMAIN } from "../../utils/domain";
import {
  AppInstallationInfoUpdateError,
  UserProfileFetchError,
} from "./common";
import { getCommonRequestHeaders } from "../../utils/axios";

const DOMAIN = HOST_DOMAIN + "/api-rewards";

export const getUserProfile = async (
  signal?: AbortSignal
): Promise<UserProfile> => {
  const headers = {
    ...(await getHeadersWithUniqueVisitorId()),
    ...getCommonRequestHeaders(),
  };
  if (!headers.Authorization) {
    throw new UserProfileFetchError("No token available");
  }
  const res = await fetch(DOMAIN + `/profile/me?refreshCache=true&cue=false`, {
    method: "GET",
    headers,
    signal,
  });

  if (res.ok) {
    return await res.json();
  } else {
    throw new UserProfileFetchError("Error fetching user profile");
  }
};

export const updateAppInstallationInfoInCheckoutBar = async (
  appInstallationInfo: IAppInstallationInfo,
  signal?: AbortSignal
): Promise<any> => {
  const headers = {
    ...(await getHeadersWithUniqueVisitorId()),
    ...getCommonRequestHeaders(),
  };
  if (!headers.Authorization) {
    return { status: "error", message: "No token available" };
  }
  const res = await fetch(DOMAIN + `/appInstallation/update`, {
    method: "POST",
    headers,
    body: JSON.stringify(appInstallationInfo),
    signal,
  });

  if (res.ok) {
    return await res.json();
  } else {
    throw new AppInstallationInfoUpdateError(
      "Error updating app installation info"
    );
  }
};
